// extracted by mini-css-extract-plugin
export default {"PropertyPoint":"PropertyPoint_PropertyPoint__dmtHl"};